import {
  Box,
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
} from '@mui/material';
import logo from 'assets/images/logo/Portal Lab Rede 3.png';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const logoDark = logo;

const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        display: flex;
        text-decoration: none;
        width: 100%;
        // width: 53px;
        justify-content: center;
        // margin: 0 auto 0 auto;
        font-weight: ${theme.typography.fontWeightBold};
`
);

const TooltipWrapper = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.colors.alpha.trueWhite[100],
    color: theme.palette.getContrastText(theme.colors.alpha.trueWhite[100]),
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 'bold',
    borderRadius: theme.general.borderRadiusSm,
    boxShadow:
      '0 .2rem .8rem rgba(7,9,25,.18), 0 .08rem .15rem rgba(7,9,25,.15)',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.colors.alpha.trueWhite[100],
  },
}));

interface IProps {
  logoWhite?: boolean;
  logoWidth?: { xs: string; md: string };
}

const Logo = ({
  logoWhite = true,
  logoWidth = { xs: '250px', md: '350px' },
}: IProps) => {
  const { t } = useTranslation();

  return (
    <TooltipWrapper title={t('Lab Rede')} arrow>
      <LogoWrapper to="/">
        <Box
          component="img"
          src={logoWhite ? logo : logoDark}
          alt="logo labrede"
          sx={{
            padding: 0,
            width: logoWidth,
          }}
        />

        {/* <Badge
          sx={{
            '.MuiBadge-badge': {
              fontSize: theme.typography.pxToRem(11),
              right: -2,
              top: 8
            }
          }}
          overlap="circular"
          color="success"
          badgeContent="3.1"
        >
          <LogoSignWrapper>
            <LogoSign>
              <LogoSignInner />
            </LogoSign>
          </LogoSignWrapper>
        </Badge> */}
      </LogoWrapper>
    </TooltipWrapper>
  );
};

export default Logo;
